import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import {CusFormLabel} from '../validation/Form-Components';
import appDetailsData from '../data/applicantdetailsdata.json';
import helper from '../factory/Helper';
import nationalitycodes from '../data/nationality.json';
import racecodes from '../data/racecode.json';
import genders from '../data/gender.json';
import residentialcodes from '../data/residentialcode.json';
import positions from '../data/position.json';
import myInfoApiCountries from '../data/myInfoApiCountryList.json';

const MyInfoDetails = (props) => {

    const{ applicantDetails, order ,fProps, ...oth} = props;
  
    const getIDNum = () => {
        
        if(applicantDetails.allowEdit) {
            return applicantDetails.myInfo.IDNum;
        }

        return helper.mask(applicantDetails.myInfo.IDNum,4);
    }

    return(
        <div>
          <Field component={CusFormLabel} 
                    leftLabelId={'lblHanPinName'} leftLabelName={appDetailsData.label.hanPinName} 
                    id={'hanPinName'} name={applicantDetails.myInfo.HanyuName !==null? applicantDetails.myInfo.HanyuName:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblAliasName'} leftLabelName={appDetailsData.label.aliName} 
                    id={'aliasName'} name={applicantDetails.myInfo.AliasName !==null? applicantDetails.myInfo.AliasName:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblHanyuAliasName'} leftLabelName={appDetailsData.label.hanPinAliName} 
                    id={'hanyuAliasName'} name={applicantDetails.myInfo.HanyuAliasName !==null? applicantDetails.myInfo.HanyuAliasName:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblmarName'} leftLabelName={appDetailsData.label.marName} 
                    id={'marriedName'} name={applicantDetails.myInfo.MarriedName !==null? applicantDetails.myInfo.MarriedName:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblIC'} leftLabelName={appDetailsData.label.ic} 
                    id={'idNum'} name={getIDNum()} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblDOB'} leftLabelName={appDetailsData.label.dob} 
                    id={'dob'} name={applicantDetails.myInfo.DOB !==null? applicantDetails.myInfo.DOB:''} />
                            
                <Field component={CusFormLabel} 
                    leftLabelId={'lblGender'} leftLabelName={appDetailsData.label.gender} 
                    id={'gender'} name={applicantDetails.myInfo.Gender && applicantDetails.myInfo.Gender !== null? helper.getObjInArray(applicantDetails.myInfo.Gender,genders).label:''} />
                            
                <Field component={CusFormLabel} 
                    leftLabelId={'lblRace'} leftLabelName={appDetailsData.label.race} 
                    id={'Race'} name={applicantDetails.myInfo.Race && applicantDetails.myInfo.Race !== null? helper.getObjInArray(applicantDetails.myInfo.Race,racecodes).label:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblNationality'} leftLabelName={appDetailsData.label.nationality} 
                    id={'nationality'} name={applicantDetails.myInfo.Nationality && applicantDetails.myInfo.Nationality !==null? helper.getObjInArray(applicantDetails.myInfo.Nationality,nationalitycodes).label:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblCountryOfBirth'} leftLabelName={appDetailsData.label.countryOfBirth} 
                    id={'countryOfBirth'} name={!applicantDetails.myInfo.CnOfBirth? '': applicantDetails.myInfo.CnOfBirth===null? '': helper.getObjInArray(applicantDetails.myInfo.CnOfBirth,myInfoApiCountries).label} />
                            
                <Field component={CusFormLabel} 
                    leftLabelId={'lblResiStatus'} leftLabelName={appDetailsData.label.resiStatus} 
                    id={'resiStatus'} name={!applicantDetails.myInfo.ResStatus?'': applicantDetails.myInfo.ResStatus === null? '': helper.getObjInArray(applicantDetails.myInfo.ResStatus,residentialcodes).label} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblDesignation'} leftLabelName={appDetailsData.label.designation} 
                    id={'designation'} name={helper.getLabelInArray(helper.getDesignationbyIDNum(applicantDetails.myInfo.IDNum,oth.holders),positions)} />
          
        </div>
    )
}

export default MyInfoDetails;